/* eslint-disable react-hooks/exhaustive-deps */
import allScreeningsDispatcher from '../../action';
import { FORMAT_LIST_TESTS } from '../../constants';
import {
  calculateTotalCost,
  formatData,
  formatExpressTotalTestServices,
  formatMeasurementInSideListTest,
  generateParamsTestIdsPackageIdsData,
  refactorPackageData,
  returnOptionalPackageTests,
} from '../../utils';
import ViewSelectPackage from '../CreateAppointment/ViewSelectPackage';
import SelecetServiceStep from './SelecetServiceStep';
import SelectPlaceAndTimeStep from './SelectPlaceAndTimeStep';
import { urlLabel } from '@/enum/PermissionEnum';
import checkinPatientDispatcher from '@/module/checkin-patient-information/action';
import companyDispatcher from '@/module/company/action';
import { packageDispatcher } from '@/module/package-management';
import patientDispatcher from '@/module/patient/actions';
import locationDispatcher from '@/module/setup/action';
import { refactorListData } from '@/module/setup/constants';
import customToast from '@/new-components/CustomNotification';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import CustomStepper from '@/new-components/CustomStepper';
import { StepperButton } from '@/new-components/CustomStepper/styled';
import { Button } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { get, cloneDeep, isEmpty } from 'lodash';
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const RescheduleAppointment = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [patientInfo, setPatientInfo] = useState({});
  const [projectInfo, setProjectInfo] = useState({});
  const [packageDetail, setPackageDetail] = useState({});
  const [dataInfo, setDataInfo] = useState({});

  const [loading, setLoading] = useState(false);

  const [timeSlot, setTimeSlot] = useState([]);
  const [timeSlotChecked, setTimeSlotChecked] = useState();
  const [closureDate, setClosureDate] = useState([]);
  const [dateChecked, setDateChecked] = useState();
  const [loadingSearchTimeSlot, setLoadingSearchTimeSlot] = useState(false);
  const [showErrorInfo, setShowErrorInfo] = useState(false);

  const [currentLocation, setCurrentLocation] = useState({});
  // HBS (homebased) locations + patient's default address for homebased payload
  const [hbsLocations, setHbsLocations] = useState([]);
  const [defaultAddressId, setDefaultAddressId] = useState(null);
  const [isValidHealthScreening, setIsValidHealthScreening] = useState(false);
  const [isRestrictPackages, setIsRestrictPackages] = useState(false);
  const [restrictedPackageIds, setRestrictedPackageIds] = useState([]);
  const [restrictedTestIds, setRestrictedTestIds] = useState([]);
  const [projectCustomFields, setProjectCustomFields] = useState([]);
  const [lstOptionalTests, setLstOptionalTests] = useState([]);
  const [currentPackage, setCurrentPackage] = useState({});
  const [dataPackageExisted, setdataPackageExisted] = useState({});
  const [locationFollowUp, setLocationFollowUp] = useState([]);
  const [lstHealthScreenings, setLstHealthScreenings] = useState([]);

  const [packageTestIds, setPackageTestIds] = useState(null);

  const [errors, setErrors] = useState({});

  const [totalCost, setTotalCost] = useState(0);
  const [totalAmountDefault, setTotalAmountDefault] = useState(0);

  const [originalPrices, setOriginalPrices] = useState({
    packages: {},
    profiles: {},
    tests: {},
  });

  const [sessionBookedPrices, setSessionBookedPrices] = useState({
    packages: {},
    profiles: {},
    tests: {},
  });

  // Use localStorage to track if user has navigated between steps (Back -> Next)
  // This persists across tab switches and component re-renders
  const getHasNavigatedBetweenSteps = () => {
    if (apptData?.id) {
      try {
        const stored = localStorage.getItem(
          `hasNavigatedBetweenSteps_${apptData.id}`
        );
        return stored === 'true';
      } catch (e) {
        return false;
      }
    }
    return false;
  };

  const setHasNavigatedBetweenSteps = (value) => {
    if (apptData?.id) {
      try {
        if (value) {
          localStorage.setItem(
            `hasNavigatedBetweenSteps_${apptData.id}`,
            'true'
          );
        } else {
          localStorage.removeItem(`hasNavigatedBetweenSteps_${apptData.id}`);
        }
      } catch (e) {
        console.error(
          'Failed to update hasNavigatedBetweenSteps in localStorage',
          e
        );
      }
    }
  };

  const [formValue, setFormValue] = useState({
    timeSlotId: '',
    date: '',
    healthScreeningId: '',
    isSuppression: false,
  });

  const location = useLocation();
  const history = useHistory();
  const apptData = get(location, 'state', {});
  const isFollowUp = get(apptData, 'isFollowUpAppointment', undefined);

  const _tempHistory = useRef();
  const ref = useRef(false);

  useEffect(() => {
    _tempHistory.current = cloneDeep(history);
  }, []);

  // Reset hasNavigatedBetweenSteps when user leaves step 1 (Select service)
  // This ensures the flag persists when switching tabs within step 1
  // but resets when user navigates to a different step
  const prevStepRef = useRef(currentStep);
  useEffect(() => {
    // Only reset if user left step 1 (was in step 1, now in different step)
    if (prevStepRef.current === 1 && currentStep !== 1) {
      setHasNavigatedBetweenSteps(false);
    }
    prevStepRef.current = currentStep;
  }, [currentStep]);

  const checkIsValidDate = (valueStartDate) => {
    const startDateUnix = moment(valueStartDate).startOf('date').unix();

    const dateCompare = isFollowUp
      ? moment().startOf('date').add(1, 'day').unix()
      : moment().startOf('date').unix();

    return startDateUnix < dateCompare;
  };

  const checkIsValidHealthScreening = (endTime) => {
    const endTimeUnix = moment(endTime).endOf('date').unix();
    const timeCompare = moment().unix();

    return endTimeUnix >= timeCompare;
  };

  const formatParamsData = (
    data,
    projectId,
    itemType = 'test',
    originalPricesMap = {}
  ) => {
    const result = { price: data.price, id: data.id, projectId };

    // Preserve total property for grouped measurements so it can be expanded later
    if (data.total && Array.isArray(data.total) && data.total.length > 0) {
      result.total = data.total;
    }

    // Preserve isUseNewPrice if it was already set (from parent propagation) - check this FIRST
    if (data.isUseNewPrice === true) {
      result.isUseNewPrice = true;
    }

    // Check if this item was previously booked with a different price
    if (originalPricesMap && Object.keys(originalPricesMap).length > 0) {
      let originalPrice = null;
      const itemId = data.id || data.testId;

      if (itemType === 'package' && originalPricesMap.packages) {
        originalPrice = originalPricesMap.packages[itemId];
      } else if (itemType === 'profile' && originalPricesMap.profiles) {
        originalPrice = originalPricesMap.profiles[itemId];
      } else if (itemType === 'test' && originalPricesMap.tests) {
        originalPrice = originalPricesMap.tests[itemId];
      }

      // If original price exists and differs from current price, mark as using new price
      if (
        originalPrice !== null &&
        originalPrice !== undefined &&
        originalPrice !== data.price
      ) {
        result.isUseNewPrice = true;
      }

      // Handle grouped measurements (items with total property)
      // For grouped measurements, compare current price with sum of original prices from total array
      if (
        itemType === 'test' &&
        data.total &&
        Array.isArray(data.total) &&
        data.total.length > 0
      ) {
        // Calculate sum of original prices from total array
        let hasOriginalPrices = false;
        const sumOriginalPrices = data.total.reduce((sum, item) => {
          const itemOriginalPrice =
            originalPricesMap.tests?.[item.id || item.testId];
          if (itemOriginalPrice !== undefined && itemOriginalPrice !== null) {
            hasOriginalPrices = true;
            return sum + itemOriginalPrice;
          }
          return sum;
        }, 0);

        // Only compare if we have at least one original price
        // If prices differ, mark as using new price
        if (hasOriginalPrices && data.price !== sumOriginalPrices) {
          result.isUseNewPrice = true;
        }
      }
    }

    return result;
  };

  // Load HBS locations to detect whether the selected location is homebased.
  useEffect(() => {
    locationDispatcher.getHomebasedLocations((res = []) =>
      setHbsLocations(res)
    );
  }, []);

  const getMatchedHbsLocation = (locationId) =>
    hbsLocations.find((l) => (l.locationId || l.id) === locationId);

  const onSubmit = () => {
    if (loading) return;
    if (!timeSlotChecked) {
      return customToast('error', 'Please select time slots');
    }

    if (isRestrictPackages) {
      return customToast(
        'error',
        'The current package has been restricted to this location. Please select another location! '
      );
    }
    setLoading(true);

    let lstTests = refactorListData(formValue);

    // Format grouped measurements BEFORE expanding (to detect price changes)
    // This allows us to set isUseNewPrice on grouped measurements
    const formattedTests = lstTests.map((test) =>
      formatParamsData(test, test.projectId, 'test', originalPrices)
    );

    // Expand grouped measurements and propagate isUseNewPrice to children
    lstTests = formatExpressTotalTestServices(formattedTests);

    // Format each expanded item again to check isUseNewPrice based on their own original prices
    // This ensures that individual items in grouped measurements are checked correctly
    // and preserves isUseNewPrice that was propagated from parent
    lstTests = lstTests.map((test) =>
      formatParamsData(test, test.projectId, 'test', originalPrices)
    );

    const params = {
      timeSlotId: formValue.timeSlotId,
      date: dateChecked,
      healthScreeningId: formValue.healthScreeningId,
      lstTests,
      lstProfiles: (formValue.lstProfiles || []).map((test) =>
        formatParamsData(test, test.projectId, 'profile', originalPrices)
      ),
      lstPackages: (formValue.lstPackages || []).map((test) =>
        formatParamsData(test, test.projectId, 'package', originalPrices)
      ),
      ignoredTests: formValue.ignoredTests,
      ignoredProfiles: formValue.ignoredProfiles,
    };

    // Homebased: if the selected location is an HBS one, send homebased fields;
    // otherwise (switched to EHS) clear them.
    const matchedHbs = getMatchedHbsLocation(currentLocation?.locationId);
    if (matchedHbs) {
      params.isHomebased = true;
      params.homebasedLocationId = matchedHbs.locationId;
      params.homebasedAddressId = defaultAddressId;
    } else {
      params.isHomebased = false;
      params.homebasedAddressId = null;
      params.homebasedLocationId = null;
    }

    allScreeningsDispatcher.rescheduleAppointment(
      apptData.id,
      params,
      (isSuccess) => {
        setLoading(false);

        if (isSuccess) {
          customToast(
            'success',
            <span>
              Appointment for patient <b>{apptData.fullName}</b> has been
              successfully rescheduled.
            </span>,
            'Appointment rescheduled'
          );
          history.push(`/${urlLabel.allScreenings}`);
        }
      }
    );
  };

  useEffect(() => {
    if (isEmpty(apptData)) return;
    const {
      startDate = '',
      appointmentTypes = [],
      nric = '',
      fullName = '',
      shortId = '',
      endDate = '',
      healthScreeningStartDate,
      healthScreeningEndDate,
      isPaxscreenSuppression,
      isProjectSuppression,
      projectId,
      healthScreeningId,
      locationId,
    } = apptData;

    let newFormValue = {
      appointmentTypes,
      nric,
      fullName,
      shortId,
      endDate,
      healthScreeningStartDate,
      healthScreeningEndDate,
      isPaxscreenSuppression,
      isProjectSuppression,
      healthScreeningId,
      locationId,
    };

    let startDateValid = moment(startDate);
    let isStartDateValid = true;
    let newLstHealthScreenings = [];

    if (checkIsValidDate(startDateValid)) {
      isStartDateValid = false;
      startDateValid = isFollowUp ? moment().add(1, 'day') : moment();

      // Check if healthScreeningStartDate is after startDateValid
      if (moment(healthScreeningStartDate).isAfter(moment(startDateValid))) {
        startDateValid = moment(healthScreeningStartDate);
      }
    }
    ref.current = isPaxscreenSuppression;
    newFormValue.startDate = startDateValid;

    onGetDataTimeSlot(startDateValid, isStartDateValid, locationId);

    companyDispatcher.getProjectByID(projectId, (result) => {
      const newListHealthScreeningsActive = result.lstHealthScreenings.filter(
        (item) => checkIsValidHealthScreening(item.endDate)
      );

      let currentLocation = newListHealthScreeningsActive.find(
        (item) => item.id === healthScreeningId
      );

      // set healthScreeningEndDate is an endDate of the project if the appointment is a follow-up
      if (isFollowUp) newFormValue.healthScreeningEndDate = result.endDate;

      if (!isFollowUp && isEmpty(newListHealthScreeningsActive)) {
        setErrors({
          location:
            'All health screenings are expired. Please update in your project!',
        });
      } else {
        setErrors({});
        if (!currentLocation && !isFollowUp) {
          currentLocation = newListHealthScreeningsActive[0];
          // Update new form value
          newFormValue.healthScreeningStartDate = currentLocation.startDate;
          newFormValue.healthScreeningEndDate = currentLocation.endDate;
          newFormValue.healthScreeningId = currentLocation.id;
          // Get data time slot with new locationId
          onGetDataTimeSlot(
            startDateValid,
            isStartDateValid,
            currentLocation.locationId
          );
        }
      }
      // Check healthScreeningEndDate is expired only with parent appointment
      setIsValidHealthScreening(
        !isFollowUp && isEmpty(newListHealthScreeningsActive)
      );
      if (!isFollowUp) setCurrentLocation(currentLocation);

      setProjectInfo((prev) => ({
        ...prev,
        id: result.id,
        code: result.code,
        pmCode: currentLocation?.pmCode,
        companyName: result.companyName,
        staffTypeLabel: result.staffTypeLabel,
        startDate: result.startDate,
        endDate: result.endDate,
        lstHealthScreenings: newListHealthScreeningsActive,
        currLocationId: apptData.locationId,
        billingType: result?.billingType,
        lstFollowUpHealthScreenings: result?.lstFollowUpHealthScreenings,
      }));
      newLstHealthScreenings = newLstHealthScreenings.concat(
        newListHealthScreeningsActive
      );
    });

    checkinPatientDispatcher.getData(apptData.id, (paxData) => {
      const {
        paxInfo,
        lstTests,
        lstProfiles,
        lstPackages,
        ignoredTests,
        ignoredProfiles,
        lstScreeningFields,
        testsByCatetory,
        doneFollowUpTests,
        locationId,
      } = paxData;

      // Extract original prices from initial booking data
      // For RescheduleAppointment, extract from paxData (current appointment data)
      let original = {
        packages: {},
        profiles: {},
        tests: {},
      };

      // Extract from lstPackages
      if (Array.isArray(lstPackages)) {
        lstPackages.forEach((pkg) => {
          if (pkg.id && pkg.price !== undefined && pkg.price !== null) {
            original.packages[pkg.id] = pkg.price;
          }
        });
      }

      // Extract from lstProfiles
      if (Array.isArray(lstProfiles)) {
        lstProfiles.forEach((profile) => {
          if (
            profile.id &&
            profile.price !== undefined &&
            profile.price !== null
          ) {
            original.profiles[profile.id] = profile.price;
          }
        });
      }

      // Extract from lstTests - handle both structured and flat formats
      if (Array.isArray(lstTests)) {
        lstTests.forEach((testItem) => {
          // Handle structured format (category with items)
          if (testItem.items && Array.isArray(testItem.items)) {
            testItem.items.forEach((test) => {
              if (test.id && test.price !== undefined && test.price !== null) {
                original.tests[test.id] = test.price;
              }
              // Extract prices from total array for grouped measurements
              if (
                test.total &&
                Array.isArray(test.total) &&
                test.total.length > 0
              ) {
                test.total.forEach((childItem) => {
                  const childId = childItem.id || childItem.testId;
                  const childPrice =
                    childItem.price !== undefined
                      ? childItem.price
                      : childItem.testPrice || 0;
                  if (
                    childId &&
                    childPrice !== undefined &&
                    childPrice !== null
                  ) {
                    original.tests[childId] = childPrice;
                  }
                });
              }
            });
          }
          // Handle flat test structure
          else if (
            testItem.id &&
            testItem.price !== undefined &&
            testItem.price !== null
          ) {
            original.tests[testItem.id] = testItem.price;
            // Extract prices from total array for grouped measurements (flat structure)
            if (
              testItem.total &&
              Array.isArray(testItem.total) &&
              testItem.total.length > 0
            ) {
              testItem.total.forEach((childItem) => {
                const childId = childItem.id || childItem.testId;
                const childPrice =
                  childItem.price !== undefined
                    ? childItem.price
                    : childItem.testPrice || 0;
                if (
                  childId &&
                  childPrice !== undefined &&
                  childPrice !== null
                ) {
                  original.tests[childId] = childPrice;
                }
              });
            }
          }
        });
      }

      setOriginalPrices(original);

      // Create sessionBookedPrices snapshot from initial data (paxData/apptData)
      // This snapshot preserves prices at the start of the reschedule session
      // and will be used to override prices in UI for selected items
      const sessionPrices = {
        packages: {},
        profiles: {},
        tests: {},
      };

      // Extract from packages
      const sourcePackages = lstPackages || [];
      if (Array.isArray(sourcePackages)) {
        sourcePackages.forEach((pkg) => {
          if (pkg.id && pkg.price !== undefined && pkg.price !== null) {
            sessionPrices.packages[pkg.id] = pkg.price;
          }
        });
      }

      // Extract from profiles
      const sourceProfiles = lstProfiles || [];
      if (Array.isArray(sourceProfiles)) {
        sourceProfiles.forEach((profile) => {
          if (
            profile.id &&
            profile.price !== undefined &&
            profile.price !== null
          ) {
            sessionPrices.profiles[profile.id] = profile.price;
          }
        });
      }

      // Extract from tests (all categories: Measurements, Procedures, Radiologies, Vaccinations, Reviews)
      const sourceTests = lstTests || [];
      if (Array.isArray(sourceTests)) {
        sourceTests.forEach((testItem) => {
          // Handle structured format (category with items)
          if (testItem.items && Array.isArray(testItem.items)) {
            testItem.items.forEach((test) => {
              if (test.id && test.price !== undefined && test.price !== null) {
                sessionPrices.tests[test.id] = test.price;
              }

              // For grouped measurements, also extract prices from total array
              if (
                test.total &&
                Array.isArray(test.total) &&
                test.total.length > 0
              ) {
                test.total.forEach((childItem) => {
                  const childId = childItem.id || childItem.testId;
                  const childPrice =
                    childItem.price !== undefined
                      ? childItem.price
                      : childItem.testPrice || 0;
                  if (
                    childId &&
                    childPrice !== undefined &&
                    childPrice !== null
                  ) {
                    sessionPrices.tests[childId] = childPrice;
                  }
                });
              }
            });
          }
          // Handle flat test structure
          else if (
            testItem.id &&
            testItem.price !== undefined &&
            testItem.price !== null
          ) {
            sessionPrices.tests[testItem.id] = testItem.price;

            // For grouped measurements, also extract prices from total array
            if (
              testItem.total &&
              Array.isArray(testItem.total) &&
              testItem.total.length > 0
            ) {
              testItem.total.forEach((childItem) => {
                const childId = childItem.id || childItem.testId;
                const childPrice =
                  childItem.price !== undefined
                    ? childItem.price
                    : childItem.testPrice || 0;
                if (
                  childId &&
                  childPrice !== undefined &&
                  childPrice !== null
                ) {
                  sessionPrices.tests[childId] = childPrice;
                }
              });
            }
          }
        });
      }

      setSessionBookedPrices(sessionPrices);

      // Have package
      if (!isEmpty(lstPackages)) {
        const { id, name, price } = lstPackages[0];
        let lstOptionalTests = [];
        packageDispatcher.getPackageById(id, (result) => {
          const {
            lstProfiles,
            lstTests: lstPackageTests,
            totalMandatoryProcedure,
            totalMandatoryRadiology,
          } = result;

          // Get list of Profile, Procedure, Radiology
          // Filter unmandatory test
          // Filter Optional test based on ingnored Test
          let lstProcedures = [];
          let lstRadiologies = [];
          let newListTest = [];
          let newTotalMandatoryProcedure = 0;
          let newTotalMandatoryRadiology = 0;

          let holdIdMandatory = [];

          if (isFollowUp && !isEmpty(doneFollowUpTests)) {
            newListTest = lstPackageTests.map((item) => {
              const holdDoneFollowUpTests = doneFollowUpTests.filter(
                (it) => it.category === item.category && !it.isAddon
              );

              return {
                ...item,
                items: item.items.filter(
                  (test) =>
                    holdDoneFollowUpTests.findIndex(
                      (item) => item.testId === test.id
                    ) === -1
                ),
              };
            });
          } else {
            newListTest = lstPackageTests;
          }

          let newLstTestProcedures = [];
          let newLstTestRadiologies = [];
          let holdDoneFollowUpTestsProcedures = [];
          let holdDoneFollowUpTestsRadiologies = [];

          lstPackageTests.forEach((item) => {
            if (item.category === 'Procedures') lstProcedures = item.items;
            if (item.category === 'Radiologies') lstRadiologies = item.items;
          });
          const unMandatoryProcedures = [...lstProcedures]?.filter(
            (it) => !it.isRequired
          );
          const unMandatoryRadiologies = [...lstRadiologies]?.filter(
            (it) => !it.isRequired
          );
          if (isFollowUp) {
            if (!isEmpty(doneFollowUpTests)) {
              // Procedure
              holdDoneFollowUpTestsProcedures = unMandatoryProcedures.filter(
                (it) => doneFollowUpTests.find((item) => item.testId === it.id)
              );

              newLstTestProcedures = unMandatoryProcedures.map((item) => {
                const itemDone = doneFollowUpTests?.find(
                  (it) => it.testId === item.id && !it.isAddon
                );

                let selectedProcedures = {};
                if (isEmpty(ignoredTests)) {
                  selectedProcedures = ignoredTests?.some((test) => {
                    return item.id === test.testId;
                  });
                } else {
                  selectedProcedures = ignoredTests?.every((test) => {
                    return item.id !== test.testId;
                  });
                }

                if (itemDone) {
                  return { ...item, isDone: true, isChecked: false };
                } else if (selectedProcedures)
                  return { ...item, isDone: false, isChecked: true };

                return { ...item, isDone: false, isChecked: false };
              });
              newLstTestProcedures = newLstTestProcedures.filter(
                (test) =>
                  holdDoneFollowUpTestsProcedures.findIndex(
                    (item) => item.id === test.id
                  ) === -1
              );

              // Radiologies
              holdDoneFollowUpTestsRadiologies = unMandatoryRadiologies.filter(
                (it) => doneFollowUpTests.find((item) => item.testId === it.id)
              );

              newLstTestRadiologies = unMandatoryRadiologies.map((item) => {
                const itemDone = doneFollowUpTests?.find(
                  (it) => it.testId === item.id && !it.isAddon
                );

                let selectedRadiologies = {};
                if (isEmpty(ignoredTests)) {
                  selectedRadiologies = ignoredTests?.some((test) => {
                    return item.id === test.testId;
                  });
                } else {
                  selectedRadiologies = ignoredTests?.every((test) => {
                    return item.id !== test.testId;
                  });
                }

                if (itemDone) {
                  return { ...item, isDone: true, isChecked: false };
                } else if (selectedRadiologies)
                  return { ...item, isDone: false, isChecked: true };

                return { ...item, isDone: false, isChecked: false };
              });

              newLstTestRadiologies = newLstTestRadiologies.filter(
                (test) =>
                  holdDoneFollowUpTestsRadiologies.findIndex(
                    (item) => item.id === test.id
                  ) === -1
              );
            } else {
              newLstTestProcedures = unMandatoryProcedures.map((item) => {
                const itemChecked = lstProcedures.find(
                  (it) => it.id === item.id
                );

                if (itemChecked) {
                  return { ...item, isDone: false, isChecked: true };
                }
                return { ...item, isDone: false, isChecked: false };
              });

              newLstTestRadiologies = unMandatoryRadiologies.map((item) => {
                const itemChecked = lstRadiologies.find(
                  (it) => it.id === item.id
                );

                if (itemChecked) {
                  return { ...item, isDone: false, isChecked: true };
                }
                return { ...item, isDone: false, isChecked: false };
              });
            }

            newTotalMandatoryProcedure =
              totalMandatoryProcedure - holdDoneFollowUpTestsProcedures.length;

            newTotalMandatoryRadiology =
              totalMandatoryRadiology - holdDoneFollowUpTestsRadiologies.length;
          } else {
            newTotalMandatoryProcedure = totalMandatoryProcedure;
            newTotalMandatoryRadiology = totalMandatoryRadiology;
          }

          // After apply doneTest

          if (isFollowUp) {
            lstOptionalTests = returnOptionalPackageTests({
              lstProcedures: newLstTestProcedures,
              lstRadiologies: newLstTestRadiologies,
              ignoredTests,
              ignoredProfiles,
            });
          } else
            lstOptionalTests = returnOptionalPackageTests({
              lstProcedures,
              lstRadiologies,
              lstProfiles,
              ignoredTests,
              ignoredProfiles,
            });

          const newPackageData = refactorPackageData({
            ...result,
            isFollowUp,
            lstProcedures,
            lstRadiologies,
            ignoredTests,
            ignoredProfiles,
          });

          const { selectedOptionalIds } = newPackageData;

          const mandatoryProcedures = lstProcedures.filter(
            (it) => it.isRequired
          );
          const mandatoryRadiologies = lstRadiologies.filter(
            (it) => it.isRequired
          );

          holdIdMandatory = mandatoryProcedures.concat(mandatoryRadiologies);
          holdIdMandatory = holdIdMandatory.map((it) => it.id);
          let packageTestIds = selectedOptionalIds.concat(holdIdMandatory);

          if (!isEmpty(doneFollowUpTests)) {
            packageTestIds = packageTestIds.filter(
              (it) =>
                doneFollowUpTests?.findIndex((d) => d.testId === it) === -1
            );
          }

          setPackageTestIds(packageTestIds);
          setLstOptionalTests(lstOptionalTests);
          setPackageDetail({
            ...result,
            lstTests: newListTest,
            lstProcedures: newLstTestProcedures,
            lstRadiologies: newLstTestRadiologies,
            totalMandatoryProcedure: newTotalMandatoryProcedure,
            totalMandatoryRadiology: newTotalMandatoryRadiology,
            name,
            price,
            holdDoneFollowUpTestsRadiologies,
            holdDoneFollowUpTestsProcedures,
          });
          setdataPackageExisted({
            ...result,
            ...lstPackages[0],
            ignoredTests,
            ignoredProfiles,
            lstProfiles,
            lstProcedures,
            lstRadiologies,
            price,
          });
          setCurrentPackage({
            ...result,
            ...lstPackages[0],
            ignoredTests,
            ignoredProfiles,
            lstProfiles,
            lstProcedures,
            lstRadiologies,
            price,
          });
        });
      }

      // Calculate total cost and total amount
      let formattedLstTests = formatMeasurementInSideListTest(lstTests);
      const newLstTests = formatData({ lstTests: formattedLstTests });
      const totalCost = calculateTotalCost({
        ...newLstTests,
        lstPackages,
        lstProfiles,
      });
      getListHealthScreenings(
        { lstPackages, ...newLstTests },
        newLstHealthScreenings
      );

      if (isFollowUp) {
        const listAddOn = lstTests.filter((it) =>
          ['Radiologies', 'Procedures', 'Vaccinations'].includes(it.category)
        );

        const formattedListAddOn = formatMeasurementInSideListTest(listAddOn);

        setDataInfo({
          ...apptData,
          lstTests: formattedListAddOn,
          lstProfiles,
          lstPackages,
          ignoredTests,
          ignoredProfiles,
          doneFollowUpTests,
          staffType: paxData?.staffType,
        });
      } else {
        // Use lstTests from destructured paxData, same as EditAppointment
        const formattedLstTests = formatMeasurementInSideListTest(
          lstTests || []
        );
        setDataInfo({
          ...paxData,
          lstTests: formattedLstTests,
        });
      }
      setProjectInfo((prev) => ({
        ...prev,
        staffType: paxData?.staffType,
      }));
      setTotalCost(totalCost);
      setTotalAmountDefault(apptData?.totalCost);

      setPatientInfo({
        fullName: paxInfo.fullName,
        identityNumber: paxInfo.identityNumber,
        dateOfBirth: paxInfo.dateOfBirth,
        nationality: paxInfo.nationality,
        ethnicGroup: paxInfo.ethnicGroup,
        mobile: paxInfo.mobile,
        email: paxInfo.email,
        countryCode: paxInfo.countryCode,
      });

      // Preload patient's default address id for the homebased (EHS->HBS) case.
      if (paxInfo?.id) {
        patientDispatcher.getUserAddress(paxInfo.id, (addresses = []) => {
          const defaultAddr =
            addresses.find((it) => it.isDefault) || addresses[0];
          setDefaultAddressId(defaultAddr?.id || null);
        });
      }
      setFormValue({
        ...newLstTests,
        timeSlotId: '',
        date: startDate,
        healthScreeningId,
        lstPackages,
        lstProfiles,
        ignoredTests,
        ignoredProfiles,
        lstScreeningFields,
        startDate: startDateValid,
        locationId,
      });
    });
  }, [apptData]);

  useEffect(() => {
    if (isEmpty(currentPackage)) {
      const { lstRadiologies, lstProcedures, lstProfiles } = packageDetail;
      const { ignoredProfiles, ignoredTests } = formValue;
      // Get list of Profile, Procedure, Radiology
      // Filter unmandatory test
      // Filter Optional test based on ingnored Test
      let lstOptionalTests = [];
      lstOptionalTests = returnOptionalPackageTests({
        lstProcedures,
        lstRadiologies,
        lstProfiles,
        ignoredTests,
        ignoredProfiles,
      });
      setLstOptionalTests(lstOptionalTests);
    } else {
      const {
        lstRadiologies,
        lstProcedures,
        lstProfiles,
        ignoredProfiles,
        ignoredTests,
      } = currentPackage;
      // Get list of Profile, Procedure, Radiology
      // Filter unmandatory test
      // Filter Optional test based on ingnored Test
      let lstOptionalTests = [];
      lstOptionalTests = returnOptionalPackageTests({
        lstProcedures,
        lstRadiologies,
        lstProfiles,
        ignoredTests,
        ignoredProfiles,
      });
      setLstOptionalTests(lstOptionalTests);
    }
  }, [formValue, packageDetail, currentPackage]);

  useEffect(() => {
    if (isEmpty(dataInfo) || isEmpty(projectInfo) || !packageTestIds) return;

    if (isFollowUp) {
      const formatTests = (lstTests) => {
        lstTests.forEach((testCategory) => {
          if (testCategory.category === 'Measurements') {
            testCategory.items = testCategory.items.reduce((prev, curr) => {
              return prev.concat(curr.total);
            }, []);
          }
        });

        return lstTests;
      };

      const lstTests = formatTests(cloneDeep(dataInfo).lstTests);
      const lstPackages = cloneDeep(dataInfo.lstPackages);

      const params = generateParamsTestIdsPackageIdsData({
        lstPackages,
        lstTests,
      });

      // Handle optional that already restricted (Procedure & Radiology)
      const newParams = {
        isFollowUp: true,
        paxScreeningId: dataInfo.id,
        testIds: params.testIds.concat(packageTestIds),
      };

      allScreeningsDispatcher.getRestrictLocationByIds(
        newParams,
        (restrictedLocationIds) => {
          const newList = [...projectInfo?.lstFollowUpHealthScreenings].filter(
            (item) => !restrictedLocationIds.includes(item.locationId)
          );

          const currLocation = newList?.find(
            (location) => location?.locationId === apptData?.locationId
          );

          setLocationFollowUp(newList);
          setCurrentLocation({
            ...currLocation,
            startDate: moment().add(1, 'day'),
          });
        }
      );
    }
  }, [dataInfo, isFollowUp, projectInfo, packageTestIds]);

  const getListHealthScreenings = (formValue, lstHealthScreenings) => {
    if (!isEmpty(lstHealthScreenings)) {
      let newLstHealthScreenings = [...lstHealthScreenings];
      let lstTests = refactorListDataCategory(formValue);

      // Get restricted location
      const params = generateParamsTestIdsPackageIdsData({
        lstPackages: formValue.lstPackages,
        lstTests,
      });
      allScreeningsDispatcher.getRestrictLocationByIds(
        params,
        (restrictedLocations) => {
          newLstHealthScreenings = newLstHealthScreenings.filter(
            (item) => !restrictedLocations?.includes(item?.locationId)
          );

          setLstHealthScreenings(newLstHealthScreenings);
        }
      );
    }
  };

  const refactorListDataCategory = (data) => {
    let newLstTests = [];
    for (const [key, value] of Object.entries(data)) {
      if (FORMAT_LIST_TESTS[key] && !isEmpty(value))
        newLstTests.push({
          category: FORMAT_LIST_TESTS[key],
          items: formatExpressTotalTestServices(value),
        });
    }

    return newLstTests;
  };

  const onGetDataTimeSlot = (value, isStartDateValid, locationId) => {
    if (!value) return;

    if (checkIsValidDate(value)) {
      setShowErrorInfo(true);
    } else {
      setShowErrorInfo(false);
    }

    if (locationId) {
      setLoadingSearchTimeSlot(true);
      locationDispatcher.getDetailLocationTimeSlot(
        {
          id: locationId,
          viewAll: true,
          date: moment(value).format('YYYY-MM-DD'),
        },
        (result) => {
          const { timeSlotId } = apptData;
          const startTimeSelected = result.find((it) => it.id === timeSlotId);

          const dayOfWeek = moment(value).day();
          const timeSlots = result.filter(
            (it) => it.dayOfWeek === dayOfWeek && !checkInvalidTimeslot(it)
          );

          const timeslotInvalid = result.filter(
            (it) => it.dayOfWeek === dayOfWeek && checkInvalidTimeslot(it)
          );
          const checkTimeslotId = timeslotInvalid?.find(
            (it) => it.id === timeSlotId
          );
          if (
            isEmpty(checkTimeslotId) &&
            startTimeSelected &&
            (!dateChecked ||
              dateChecked === moment(value).startOf('date').format())
          ) {
            isStartDateValid &&
              !isFollowUp &&
              setTimeSlotChecked(startTimeSelected.id);

            setDateChecked(moment(value).startOf('date').format());
          }
          setTimeSlot(timeSlots);
          setLoadingSearchTimeSlot(false);
        }
      );
      // locationDispatcher.getDetailLocation(apptData.locationId, result => {
      //   setClosureDate(result?.dayOffs);
      // });
    }
  };

  const checkInvalidTimeslot = (row) => {
    const { startDate, endDate, isActive } = row;
    // Disable Time Slot:
    // 1 Start time valid is after current time
    // 2 Start date valid is after current date 2 days
    // 3 Timeslot not active
    // 3 Timeslot not active
    // 4 End time valid is before current 5 minutes

    if (checkIsValidDate(startDate)) return true;
    if (checkIsValidTime(endDate)) return true;
    if (checkIsValidTime5Mins(endDate)) return true;

    if (!isActive) return true;

    return;
  };

  const checkIsValidTime = (startTime) => {
    const startTimeUnix = moment(startTime).unix();
    const timeCompare = moment().unix();

    return startTimeUnix <= timeCompare;
  };

  const checkIsValidTime5Mins = (endTime) => {
    const endTime5Mins = moment(endTime).subtract(5, 'minutes');
    const timeCompare = moment();
    const diffTime = endTime5Mins.diff(timeCompare, 'minutes');

    return diffTime < 0;
  };

  const getDetailLocation = (locationId) => {
    locationDispatcher.getDetailLocation(locationId, (result) => {
      if (result.restrictedPackageIds) {
        checkinPatientDispatcher.getData(apptData?.id, (resultPax) => {
          const packageIds = resultPax.lstPackages.map((test) => test.id);
          const restrictedPackageIds = result.restrictedPackageIds;
          const hasRestrictedIds = restrictedPackageIds.filter((id) =>
            packageIds.includes(id)
          );
          setIsRestrictPackages(!isEmpty(hasRestrictedIds));
        });
      }
      setClosureDate(result?.dayOffs);
      setRestrictedPackageIds(result?.restrictedPackageIds);
      setRestrictedTestIds(result?.restrictedTestIds);
    });
  };
  const handleChangeData = (data, filterKey) => {
    let allTest = [];
    data.forEach((prj) => {
      allTest = allTest.concat(prj.items);
    });
    const selectedData = allTest.filter((test) => test.isChecked);

    // Update sessionBookedPrices with new prices when items are reselected with new prices
    setSessionBookedPrices((prevSessionPrices) => {
      const updatedSessionPrices = { ...prevSessionPrices };

      selectedData.forEach((item) => {
        const itemId = item.id || item.testId;
        if (!itemId) return;

        // If item has isUseNewPrice = true, it means it was reselected with new price
        // Update sessionBookedPrices with the new price
        if (
          item.isUseNewPrice === true &&
          item.price !== undefined &&
          item.price !== null
        ) {
          if (filterKey === 'lstPackages') {
            updatedSessionPrices.packages = {
              ...updatedSessionPrices.packages,
              [itemId]: item.price,
            };
          } else if (filterKey === 'lstProfiles') {
            updatedSessionPrices.profiles = {
              ...updatedSessionPrices.profiles,
              [itemId]: item.price,
            };
          } else {
            // For tests (all other filterKeys)
            updatedSessionPrices.tests = {
              ...updatedSessionPrices.tests,
              [itemId]: item.price,
            };

            // Also update prices for grouped measurements (items with total array)
            if (
              item.total &&
              Array.isArray(item.total) &&
              item.total.length > 0
            ) {
              item.total.forEach((childItem) => {
                const childId = childItem.id || childItem.testId;
                const childPrice =
                  childItem.price !== undefined
                    ? childItem.price
                    : childItem.testPrice;
                if (
                  childId &&
                  childPrice !== undefined &&
                  childPrice !== null
                ) {
                  updatedSessionPrices.tests = {
                    ...updatedSessionPrices.tests,
                    [childId]: childPrice,
                  };
                }
              });
            }
          }
        }
      });

      return updatedSessionPrices;
    });

    const totalCost = calculateTotalCost({
      ...formValue,
      [filterKey]: selectedData,
    });
    setFormValue({ ...formValue, [filterKey]: selectedData });
    setTotalCost(totalCost);
  };

  const selectPlaceDataInfo = isEmpty(dataInfo) ? apptData : dataInfo;

  const STEPS = [
    {
      name: 'Select place and time',
      component: (
        <SelectPlaceAndTimeStep
          errors={errors}
          setErrors={setErrors}
          dataInfo={selectPlaceDataInfo}
          patientInfo={patientInfo}
          projectInfo={projectInfo}
          formValue={formValue}
          setFormValue={setFormValue}
          setCurrentLocation={setCurrentLocation}
          currentLocation={currentLocation}
          isFollowUp={isFollowUp}
          onGetDataTimeSlot={onGetDataTimeSlot}
          getDetailLocation={getDetailLocation}
          timeSlot={timeSlot}
          setTimeSlot={setTimeSlot}
          timeSlotChecked={timeSlotChecked}
          setTimeSlotChecked={setTimeSlotChecked}
          dateChecked={dateChecked}
          setDateChecked={setDateChecked}
          closureDate={closureDate}
          showErrorInfo={showErrorInfo}
          setIsRestrictPackages={setIsRestrictPackages}
          locationFollowUp={locationFollowUp}
          lstHealthScreenings={lstHealthScreenings}
          setProjectInfo={setProjectInfo}
        />
      ),
    },

    {
      name: 'Select service',
      component: isFollowUp ? (
        <ViewSelectPackage
          packageDetail={packageDetail}
          formValue={formValue}
          paymentStatus={apptData.paymentStatus}
          lstOptionalTests={lstOptionalTests}
          dataInfo={dataInfo}
          apptData={apptData}
          projectInfo={projectInfo}
          restrictedTestIds={restrictedTestIds}
          staffType={formValue?.staffType || dataInfo?.staffType}
        />
      ) : (
        <SelecetServiceStep
          apptData={apptData}
          projectInfo={projectInfo}
          formValue={formValue}
          setFormValue={setFormValue}
          handleChangeData={handleChangeData}
          packageDetail={packageDetail}
          setPackageDetail={setPackageDetail}
          projectCustomFields={projectCustomFields}
          lstOptionalTests={lstOptionalTests}
          setCurrentPackage={setCurrentPackage}
          currentPackage={currentPackage}
          dataPackageExisted={dataPackageExisted}
          locationId={formValue?.locationId}
          restrictedPackageIds={restrictedPackageIds}
          restrictedTestIds={restrictedTestIds}
          dataInfo={dataInfo}
          originalPrices={originalPrices}
          sessionBookedPrices={sessionBookedPrices}
          isFollowUp={isFollowUp}
        />
      ),
    },
  ];

  if (!location.state) history.push(`/${urlLabel.allScreenings}`);

  const onCancel = () => history.push(`/${urlLabel.allScreenings}`);

  const StepperButtons = () => (
    <Box display="flex" justifyContent="flex-end" p={1.25}>
      <StepperButton
        className="secondary"
        disabled={currentStep === 0}
        onClick={() => {
          if (currentStep === 1) {
            setHasNavigatedBetweenSteps(true);
          }
          setCurrentStep(currentStep - 1);

          getListHealthScreenings(formValue, projectInfo?.lstHealthScreenings);
        }}
      >
        Back
      </StepperButton>
      <StepperButton
        disabled={isValidHealthScreening || isEmpty(timeSlotChecked)}
        onClick={() => {
          if (currentStep === STEPS.length - 1) {
            onSubmit();
          } else {
            if (currentStep === 0) {
              setHasNavigatedBetweenSteps(true);
            }
            setCurrentStep(currentStep + 1);
          }
        }}
      >
        {currentStep === STEPS.length - 1 ? 'Reschedule' : 'Next'}
      </StepperButton>
    </Box>
  );

  return (
    <>
      <CustomPaperContainer
        header={
          <CustomHeader
            title={`Reschedule appointment`}
            isSearch={false}
            renderButton={() => (
              <>
                <Button color="primary" variant="outlined" onClick={onCancel}>
                  Cancel
                </Button>
              </>
            )}
          />
        }
        children={() => (
          <Paper square>
            <CustomStepper
              steps={STEPS}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              disableNext
              renderButtons={StepperButtons}
            >
              <Box height="calc(100vh - 280px)" overflow="scroll">
                {STEPS && STEPS[currentStep]?.component}
              </Box>
            </CustomStepper>
          </Paper>
        )}
      />
    </>
  );
};

export default RescheduleAppointment;
